import script from "./IconBoxs.vue?vue&type=script&setup=true&lang=js"
export * from "./IconBoxs.vue?vue&type=script&setup=true&lang=js"

import "./IconBoxs.vue?vue&type=style&index=0&id=4f833287&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/inticons/inticons/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f833287"]])

export default __exports__